import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import CloseIcon from "@mui/icons-material/Close";
import { useState } from "react";

import { browserStorage, storageEntries } from "@/shared/browser-storage";

function isDataCollectionNoticeDismissed(): boolean {
  return browserStorage.read(storageEntries.dataCollectionNoticeDismissed) === true;
}

export function DataCollectionNotice() {
  const [isDismissed, setIsDismissed] = useState(isDataCollectionNoticeDismissed);
  const [dontShowAgain, setDontShowAgain] = useState(false);

  const handleClose = () => {
    if (dontShowAgain) {
      browserStorage.write(storageEntries.dataCollectionNoticeDismissed, true);
    }
    setIsDismissed(true);
  };

  if (isDismissed) {
    return null;
  }

  return (
    <Alert
      severity="warning"
      sx={{
        py: 1.5,
        px: 2,
        "& .MuiAlert-message": {
          display: "flex",
          alignItems: "center",
          gap: 2,
          width: "100%",
          py: 0,
        },
      }}
    >
      <Box sx={{ flex: 1 }}>
        Some data is unavailable or still being collected. Charts and insights may be incomplete;
        historical data can take up to four weeks to appear.
      </Box>
      <Button
        size="small"
        onClick={handleClose}
        color="error"
        startIcon={<CloseIcon fontSize="small" />}
        sx={{
          flexShrink: 0,
          whiteSpace: "nowrap",
        }}
      >
        Close
      </Button>
      <FormControlLabel
        control={
          <Checkbox
            checked={dontShowAgain}
            onChange={(e) => setDontShowAgain(e.target.checked)}
            size="small"
          />
        }
        label="Don't show again"
        sx={{
          m: 0,
          flexShrink: 0,
          whiteSpace: "nowrap",
          "& .MuiFormControlLabel-label": {
            fontSize: "0.875rem",
          },
        }}
      />
    </Alert>
  );
}
